import { render, staticRenderFns } from "./StatBar.vue?vue&type=template&id=2e4f7a12&scoped=true&"
import script from "./StatBar.vue?vue&type=script&lang=js&"
export * from "./StatBar.vue?vue&type=script&lang=js&"
import style0 from "./StatBar.vue?vue&type=style&index=0&id=2e4f7a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4f7a12",
  null
  
)

export default component.exports